// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1637768517846
      var cssReload = require("/home/local/jenkins-qa/slave_data/workspace/website+bondscanner/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  